import { InjectionToken } from '@angular/core';
// tslint:disable-next-line: no-absolute-import
import { environment } from 'src/environments/environment';

export const WS_CONFIG = new InjectionToken<SocketIoConfig>('cs-ws-config', {
  providedIn: 'root',
  factory: () => ({
    url: `${environment.nodeService}call-center`,
    options: {
      path: '/clove.build',
      reconnectionAttempts: 5,
      transportOptions: {
        polling: {
          extraHeaders: {
            'ngsw-bypass': 'clear'
          }
        }
      }
    }
  })
});

export type CsSocketState = 'Initializing' | 'Connected' | 'Disconnected';

export interface SocketIoConfig {
  url: string;
  options?: SocketIOClient.ConnectOpts;
}
